import { Box, Flex, Paper, Text } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { NumberInput, Tooltip } from '@components';
import { EVALUATION_IMADB_PERCENTAGE_FACTOR } from '@constants';
import { toDecimal } from '@utils';
import { renderActiveMethodButton } from './CustomerViewEvaluationMethods';
import classes from './CustomerViewEvaluationMethods.module.css';
import { CustomerViewEvaluationMethodsFormValues } from './useCustomerViewEvaluationMethodsFormInitializer';

interface CustomerViewEvaluationIMADBStatisticalValueProps {
  form: UseFormReturnType<CustomerViewEvaluationMethodsFormValues>;
}

export const CustomerViewEvaluationIMADBStatisticalValue: React.FC<CustomerViewEvaluationIMADBStatisticalValueProps> = ({ form }) => {
  const { evaluationMethods } = form.values;

  return (
    <Paper
      className={`${classes.evaluationMethodContainer} ${
        evaluationMethods.evalMethodIMADBStatisticalValue?.activateMethod || false ? classes.activeMethod : ''
      }`}
    >
      <Flex>
        <Box className={classes.evaluationMethodContainerHeaderBody}>
          <Text fz={14} mb={10}>
            EvalMethod IMADB Statistical Value
          </Text>
        </Box>
        {renderActiveMethodButton(
          form,
          evaluationMethods.evalMethodIMADBStatisticalValue?.activateMethod || false,
          'evaluationMethods.evalMethodIMADBStatisticalValue.activateMethod',
        )}
      </Flex>

      <Box className={classes.evaluationMethodFormRow} pt={25} pb={30}>
        <NumberInput
          {...form.getInputProps('evaluationMethods.evalMethodIMADBStatisticalValue.minimumRate')}
          label="Minimum rate (%)"
          onChange={(value) => {
            form.setFieldValue('evaluationMethods.evalMethodIMADBStatisticalValue.minimumRate', Number(value) / EVALUATION_IMADB_PERCENTAGE_FACTOR);
          }}
          value={toDecimal(Number(evaluationMethods.evalMethodIMADBStatisticalValue?.minimumRate) * EVALUATION_IMADB_PERCENTAGE_FACTOR)}
        />
        <Tooltip content="Minimum rate (%) = invoiced value (€ / kg) / statistical value (€/kg)" />
      </Box>
    </Paper>
  );
};
